import { SearchTabsProps } from "../../types/components.types";

// The component below renders the 'MPAN', 'Address', and 'MSN' tab buttons.
// It uses the 'activeTab' prop to determine which tab is currently selected.
// onTabChange updates the activeTab when a user clicks on a specific tab.
const SearchTabs: React.FC<SearchTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="search-tabs">
      <button
        // If 'activeTab' is 'mpan', add the 'active' class to highlight the selected tab.
        data-testid="electralink-tab-mpan"
        className={`tab-button ${activeTab === "mpan" ? "active" : ""}`}
        // Call the 'onTabChange' with 'mpan' to update the active tab.
        onClick={() => {
          onTabChange("mpan");
        }}
      >
        MPAN
      </button>
      <button
        data-testid="electralink-tab-address"
        className={`tab-button ${activeTab === "address" ? "active" : ""}`}
        onClick={() => {
          onTabChange("address");
        }}
      >
        Address
      </button>
      <button
        data-testid="electralink-tab-msn"
        className={`tab-button ${activeTab === "msn" ? "active" : ""}`}
        onClick={() => {
          onTabChange("msn");
        }}
      >
        MSN
      </button>
    </div>
  );
};

export default SearchTabs;
